"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyLicenseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const atoms_1 = require("../../atoms");
const LicensePrice_1 = require("../LicensePrice");
const licenses_1 = require("../../utils/licenses");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
function BuyLicenseButton({ license, onBuy, isOpen, }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const isLandscape = (0, ui_1.useOrientation)();
    const licenseStrings = (0, licenses_1.stringsForLicenseType)(license.type);
    const title = (0, i18n_1.Localized)(licenseStrings.name);
    const platform = (0, i18n_1.Localized)(licenseStrings.platform);
    const description = (0, i18n_1.Localized)(licenseStrings.shortDescription);
    if (isMobile && isLandscape) {
        return ((0, jsx_runtime_1.jsxs)(TopContainer, { "data-e2e": 'BuyLicenseButton_TopContainer', children: [(0, jsx_runtime_1.jsx)(LicenseDescription, { "data-e2e": 'BuyLicenseButton_LicenseDescription', children: description }), (0, jsx_runtime_1.jsxs)(Column, { "data-e2e": 'BuyLicenseButton_Column', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'BuyLicenseButton_Title', children: title }), (0, jsx_runtime_1.jsx)(Platform, { "data-e2e": 'BuyLicenseButton_Platform', children: platform }), (0, jsx_runtime_1.jsx)(atoms_1.PrimaryButton, { onClick: onBuy, "data-e2e": 'BuyLicenseButton_PrimaryButton', children: (0, i18n_1.Localized)(i18n_1.Strings.store.confirmPay) })] }), (0, jsx_runtime_1.jsx)(PriceContainer, { "$isOpen": isOpen, "data-e2e": 'BuyLicenseButton_PriceContainer', children: (0, jsx_runtime_1.jsx)(LicensePrice_1.LicensePrice, { license: license, "data-e2e": 'BuyLicenseButton_LicensePrice' }) })] }));
    }
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { addEndListener: (node, onEnd) => node.addEventListener('transitionend', onEnd), in: isOpen, appear: true, "data-e2e": 'BuyLicenseButton_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'BuyLicenseButton_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'BuyLicenseButton_Title', children: title }), (0, jsx_runtime_1.jsx)(PriceContainer, { "$isOpen": isOpen, "data-e2e": 'BuyLicenseButton_PriceContainer', children: (0, jsx_runtime_1.jsx)(LicensePrice_1.LicensePrice, { license: license, "data-e2e": 'BuyLicenseButton_LicensePrice' }) }), (0, jsx_runtime_1.jsx)(ConfirmButton, { onClick: onBuy, "data-e2e": 'BuyLicenseButton_ConfirmButton', children: (0, i18n_1.Localized)(i18n_1.Strings.store.confirmPay) })] }) }));
}
exports.BuyLicenseButton = BuyLicenseButton;
const Title = styled_components_1.default.div `
  flex-shrink: 0;

  margin: 10px auto 5px auto;

  color: ${({ theme }) => theme.text};

  font-size: 28px;
  text-align: center;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: auto;
    flex-basis: 35%;
  `)}
`;
const PriceContainer = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;

  margin: 130px auto 20px auto;

  transition: margin-top 0.3s ease-in-out;
  transition-delay: ${({ $isOpen }) => ($isOpen ? '0' : '0.3s')};

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    flex-basis: 35%;
  `)}
`;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  &.enter-active
    ${PriceContainer},
    &.appear-active
    ${PriceContainer},
    &.enter-done
    ${PriceContainer},
    &.appear-done
    ${PriceContainer},
    &.exit
    ${PriceContainer} {
    margin-top: 10px;
  }

  &.exit-active ${PriceContainer}, &.exit-done ${PriceContainer} {
    margin-top: 130px;
  }
`;
const ConfirmButton = (0, styled_components_1.default)(atoms_1.PrimaryButton) `
  margin-bottom: 10px;

  &:focus-visible {
    outline: ${({ theme }) => `2px solid ${theme.greenSecondary}`};
    outline-offset: 3px;
  }
`;
const TopContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const Platform = styled_components_1.default.div `
  margin: 0 auto;

  color: ${({ theme }) => theme.text};

  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
`;
const LicenseDescription = styled_components_1.default.div `
  max-width: 180px;

  margin: auto 20px;

  color: ${({ theme }) => theme.textSecondary};

  font-size: 14px;
  text-align: center;
`;
const Column = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  margin: 0 20px;

  flex-basis: 35%;
`;
